import React from 'react';
import * as Types from './action_types'

const initialState = {
  favorites: [],
  favoritesCount: 0,
  toast: undefined
};

// Reducer
export default function favoritesReducer(state = initialState, action) {
  switch (action.type) {
    case Types.FETCH_SUCCESS:
      return {
        ...state,
        favorites: action.favorites
      };
    case Types.LOVE:
      return {
        ...state,
        favorites: state.favorites.concat(action.favorite),
        toast: (
          <span>
            Added to <a href="/your-favorites/inspiration" target="_blank">your favorites</a>
          </span>
        ),
        favoritesCount: state.favoritesCount + 1
      };
    case Types.UNLOVE:
      return {
        ...state,
        favorites: removeFavorite(state.favorites, action.favorite_id),
        toast: (
          <span>
            Removed from <a href="/your-favorites/inspiration" target="_blank">your favorites</a>
          </span>
        ),
        favoritesCount: state.favoritesCount - 1
      };
    case Types.CLEAR_TOAST:
      return {
        ...state,
        toast: undefined
      };
    case Types.CLEAR:
      return initialState;
    case Types.UPDATE_FAVORITES_COUNT:
      return {
        ...state,
        favoritesCount: action.count
      };
    default:
      return state;
  }
}

function removeFavorite(favorites, favorite_id) {
  let index = favorites.findIndex(function (favorite) {
    return favorite.id === favorite_id
  });

  if(index > -1) {
    favorites.splice(index, 1);
  }

  return favorites;
}
